import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import {
	ClassifierAssignmentDto,
	TagRes,
	CreateTagDto,
	UpdateTagDto,
} from '@dealstack/shared/lib/generated';

export const listTags = async (params?: {
	/**
	 * Tri-state archive filter:
	 *   undefined → no filter (active + archived)
	 *   true      → only archived
	 *   false     → only active
	 */
	isArchived?: boolean;
}) => {
	return await makeRequest<ApiV1.Response<TagRes[]>>({
		endpoint: API_PATHS.TAG_GET,
		method: HTTP_METHOD.GET,
		queryString: {
			...(typeof params?.isArchived === 'boolean' ? { isArchived: params.isArchived } : {}),
		},
	});
};

export const createTag = async (body: CreateTagDto) => {
	return await makeRequest<ApiV1.Response<TagRes>>({
		endpoint: API_PATHS.TAG_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	});
};

export const updateTag = async (args: { tagId: string; body: UpdateTagDto }) => {
	return await makeRequest<ApiV1.Response<TagRes>>({
		endpoint: formatUnicorn(API_PATHS.TAG_TAGID_PATCH, {
			tagId: args.tagId,
		}),
		method: HTTP_METHOD.PATCH,
		body: JSON.stringify(args.body),
	});
};

export const deleteTag = async (args: { tagId: string }) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.TAG_TAGID_DELETE, {
			tagId: args.tagId,
		}),
		method: HTTP_METHOD.DELETE,
	});
};

export const attachClassifiersToTag = async (args: {
	tagId: string;
	body: ClassifierAssignmentDto;
}) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.TAG_TAGID_CLASSIFIERS_ATTACH_POST, {
			tagId: args.tagId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args.body),
	});
};

export const detachClassifiersFromTag = async (args: {
	tagId: string;
	body: ClassifierAssignmentDto;
}) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.TAG_TAGID_CLASSIFIERS_DETACH_POST, {
			tagId: args.tagId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args.body),
	});
};
